/**
 * IMPORT CORE DI ANGULAR
 */
import { MainHomeComponent } from './home/home.component';
import { MainComponent } from './main.component';
import { Routes } from '@angular/router';
import { HomepageResolver } from '../shared/_resolver/homepage.resolver';
import { InstallatoriResolver } from '../shared/_resolver/installatori.resolver';
import { MainResolver } from '../shared/_resolver/main.resolver';
import { MetaGuard } from '@ngx-meta/core';
import { PaginaNonTrovataComponent } from './pagina-non-trovata/pagina-non-trovata.component';
import { PagamentoAnnullatoComponent } from './carrello/pagamento-annullato/pagamento-annullato.component';
import { RegistrazioneComponent } from './registrazione/registrazione.component';
import { CardListConfiguratoreComponent } from './card-list-configuratore/card-list-configuratore.component';
import { GradinatoreResolver } from '../shared/_resolver/gradinatore.resolver';
import { LoginComponent } from '../shared/_component/login/login.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { RicercaGenericaComponent } from './ricerca-generica/ricerca-generica.component';
import { InstallatoriComponent } from './installatori/installatori.component';
import { ContattiComponent } from './contatti/contatti.component';
var ɵ0 = function () { return import("./area-riservata/area-riservata.module.ngfactory").then(function (m) { return m.AreaRiservataModuleNgFactory; }); }, ɵ1 = function () { return import("./carrello/carrello.module.ngfactory").then(function (m) { return m.CarrelloModuleNgFactory; }); }, ɵ2 = function () { return import("./informazioni/informazioni.module.ngfactory").then(function (m) { return m.InformazioniModuleNgFactory; }); }, ɵ3 = function () { return import("./dynamic-schede/dynamic-schede.module.ngfactory").then(function (m) { return m.DynamicSchedeModuleNgFactory; }); };
var routes = [
    {
        path: '',
        canActivateChild: [MetaGuard],
        component: MainComponent,
        resolve: { MainResolver: MainResolver },
        children: [
            {
                path: '',
                component: MainHomeComponent,
                resolve: { HomepageResolver: HomepageResolver }
            },
            {
                path: '404',
                component: PaginaNonTrovataComponent,
            },
            {
                path: 'carrello/pagamento-annullato',
                component: PagamentoAnnullatoComponent,
            },
            {
                path: 'registrazione',
                component: RegistrazioneComponent,
            },
            {
                path: 'reset-password',
                component: ResetPasswordComponent
            },
            {
                path: 'ricerca-generica',
                component: RicercaGenericaComponent
            },
            {
                path: 'login',
                component: LoginComponent,
            },
            {
                path: 'installatori',
                component: InstallatoriComponent,
                resolve: { InstallatoriResolver: InstallatoriResolver }
            },
            {
                path: 'contatti',
                component: ContattiComponent,
            },
            {
                path: 'configuratore',
                component: CardListConfiguratoreComponent,
                resolve: { GradinatoreResolver: GradinatoreResolver }
            },
            {
                path: 'area-riservata',
                loadChildren: ɵ0,
            },
            {
                path: 'carrello',
                loadChildren: ɵ1,
            },
            {
                path: 'informazioni',
                loadChildren: ɵ2,
            },
            {
                path: ':categoriaScheda',
                loadChildren: ɵ3,
            }
        ]
    }
];
var MainModule = /** @class */ (function () {
    function MainModule() {
    }
    return MainModule;
}());
export { MainModule };
export { ɵ0, ɵ1, ɵ2, ɵ3 };
